import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { cloneDeep } from 'lodash';

class BranchToClassSingleDD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardId: null,
            classId: null,
            branchId: null,
            boards: [],
            classes: [],
        };
    }

    componentDidMount() {
        this.getData();
        
        // Get filtered branches first
        const filteredBranchData = this.getFilteredBranches();
        
        // Auto select first branch on mount
        if (filteredBranchData.length > 0) {
            this.onChangeBranch(filteredBranchData[0].key);
        }
    }

    getData = () => {
       /*  this.props.getBranchesLatest();
        this.props.getBoardsData(true) */
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );
        
        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchId) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = boards || [];

        // Filter by selected branch
        if (selectedBranchId) {
            filteredBoards = filteredBoards.filter(board => 
                board.assignedBranches.includes(selectedBranchId)
            );
        }

        // If user is admin, return boards filtered only by selected branch
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(filteredBoards, 'boardId');
        }

        // For teachers, additionally filter by assigned boards
        if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }
        // For non-admin, non-teacher users, filter by assigned boards if available
        else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }

        // Remove duplicate boards by boardId
        return this.removeDuplicates(filteredBoards, 'boardId');
    }

    onChangeBranch = (branchId) => {
        this.setState({
            boards: [],
            classes: []
        });

        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;
        
        // Use filtered boards based on selected branch and user role
        let filteredBoards = this.getFilteredBoards(branchId);

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: filteredBoards,
            classes: [],
            boardId: '',
            selectedBoardName: '',
            classId: null,
            selectedClass: null,
            selectedClassName: '',
        }, () => {
           

            // Auto-select first board if available
            if (filteredBoards.length > 0) {
                this.onChangeBoard(filteredBoards[0].boardId);
            }
        });
    };

    onChangeBoard = (boardId) => {
        this.setState({
            classes: []
        });

        const selectedBoard = boardId && this.state.boards &&
            (this.state.boards.find((board) => board.boardId === boardId) ||
                this.props.boards.find((board) => board.boardId === boardId));

        if (!selectedBoard) {
            console.warn('Selected board not found');
            this.setState({
                classes: [],
                boardId: '',
                selectedBoardName: '',
                classId: null,
                selectedClass: null,
                selectedClassName: '',
            }, );
            return;
        }

        // Remove duplicate classes
        const uniqueClasses = this.removeDuplicates(selectedBoard.classes || [], 'classId');

        this.setState({
            classes: uniqueClasses,
            boardId,
            selectedBoardName: selectedBoard.boardName || '',
            classId: null,
            selectedClass: null,
            selectedClassName: '',
        }, () => {
           

            // Auto-select first class if available
            if (uniqueClasses.length > 0) {
                this.onChangeClass(uniqueClasses[0].classId);
            }
        });
    };

    onChangeClass = (classId) => {
        let selectedClass = this.state.classes ?
            this.state.classes.find((classd) => classd.classId === classId) :
            null;

        this.setState({
            classId: classId,
            selectedClass: selectedClass,
            selectedClassName: selectedClass?.className || '',
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardId,
            classId,
            branchId,
            selectedBoardName,
            selectedClassName,
            selectedbranchName
        } = this.state
        let returnData = {
            boardId,
            classId,
            branchId,
            selectedBoardName,
            selectedClassName,
            selectedbranchName
        }
        this.props.setValues(returnData)
    }

    render() {
        // Get filtered branches for the dropdown options
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div className='grid'>
                    <div className="col-12">
                        <div className="row-3 my-2">
                            <ClassetDropdown
                                required={true}
                                label={'Branch'}
                                placeholder={'Select Branch'}
                                options={filteredBranchData}
                                value={this.state.branchId}
                                disabled={this.props?.disable >= 1}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key"
                            />
                        </div>
                        <div className="row-3 my-2">
                            <ClassetDropdown
                                required={true}
                                label={'Board'}
                                placeholder={'Select Board'}
                                options={this.state?.boards}
                                value={this.state.boardId}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId"
                                disabled={this.props?.disable >= 2}
                            />
                        </div>
                        <div className="row-3 my-2">
                            <ClassetDropdown
                                required={true}
                                label="Class"
                                value={this.state.classId}
                                options={this.state.classes.map((classd) => ({
                                    label: classd.className,
                                    value: classd.classId
                                }))}
                                onChange={(e) => this.onChangeClass(e.value)}
                                disabled={!this.state.boardId}
                                placeholder="Select Class"
                                className="w-100"
                            />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});

export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToClassSingleDD);